// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__al+TZ","todos":"Dashboard_todos__B1eGZ"};